/** @file Inverse of a parent affine; a degenerate one (|det| < 1e-12) inverts its translation only. */
import { affine } from '@pose2d/math/affine';
import type { Affine } from '@pose2d/math/types';
import { readNum } from './readNum';

/** Below this |det| a parent counts as degenerate (e.g. a zero scale) and its linear part as identity (R4-03). */
const DET_EPS = 1e-12;

/** Writes the inverse of m into out; a degenerate m gives the translation-only inverse [1, 0, 0, 1, -tx, -ty]. */
export function invertParent(out: Affine, m: Affine): Affine {
  const det = readNum(m, 0) * readNum(m, 3) - readNum(m, 1) * readNum(m, 2);
  if (Math.abs(det) >= DET_EPS) return affine.invert(out, m);
  affine.identity(out);
  out[4] = -readNum(m, 4);
  out[5] = -readNum(m, 5);
  return out;
}
